import { render, staticRenderFns } from "./SectionCategory.vue?vue&type=template&id=cc469a04&scoped=true&lang=pug&"
import script from "./SectionCategory.vue?vue&type=script&lang=js&"
export * from "./SectionCategory.vue?vue&type=script&lang=js&"
import style0 from "./SectionCategory.vue?vue&type=style&index=0&id=cc469a04&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc469a04",
  null
  
)

export default component.exports